<div>
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
        <div style="text-align: center;">
            <strong>Department Name: {{ data.jobCardData[0].taskDeptName }}</strong>
            <div style="margin-top: 10px;" *ngIf="data.jobCardData[0].complaintStatus === 'JOBCARDISSUED'">
                <mat-form-field appearance="outline">
                    <mat-label>Department</mat-label>
                    <mat-select placeholder="Department" [(ngModel)]="departmentId" (selectionChange)="getEmployeesForDepartment(departmentId.toString())">
                        <mat-option *ngFor="let department of departments" [value]="department.code">
                            {{ department.value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div style="margin-top: 15px;">
                <mat-form-field appearance="outline">
                    <mat-label>Field staff</mat-label>
                    <mat-select placeholder="Select Employee" [(ngModel)]="employeeId">
                        <mat-option *ngFor="let employee of employees" [value]="employee.code" [disabled]="isEmployeeDisabled(employee)">
                          {{ employee.value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Comments</mat-label>
                    <textarea [(ngModel)]="comments" matInput placeholder="Leave a comment..."></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-stroked-button (click)="onNoClick()">Back</button>
        <button mat-flat-button [mat-dialog-close]="event()" [disabled]="!employeeId" (click)="onApproved()">Issue Job Card</button>
    </mat-dialog-actions>
</div>

